import * as React from "react";
import type { SVGProps } from "react";
const SvgFailedErpIdle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={18}
    fill="none"
    viewBox="0 0 25 18" {...props}
  >
    <rect width={18} height={18} fill="#E9F5FF" rx={4} />
    <path
      fill="#BACCDB"
      d="M4.143 6.757h2.1v4.866H7.29v1.902H4.143zm9.726 4.477h-2.102V6.368h-1.046V4.467h3.148z"
    />
    <path
      fill="#8BB0C9"
      d="M3.654 4h6.641v5.558L7.742 6.35H3.654zm10.693 10h-6.64V8.443l2.552 3.206h4.088"
    />
    <circle cx={18} cy={4} r={4} fill="#FF5252" />
  </svg>
);
export default SvgFailedErpIdle;
